<template>
  <!-- Map container with accessibility role -->
  <div
    id="map"
    class="w-full h-[500px] rounded-xl shadow-md"
    role="application"
    aria-label="Interactive map showing searched location"
  ></div>
</template>

<script setup>
import { ref, onMounted, watch } from "vue";
import L from "leaflet";
import { defineProps } from "vue";

// Props
const props = defineProps({
  coordinates: {
    type: Array,
    default: () => [40.22, -3.7038],
  },
  popupText: {
    type: String,
    default: "",
  },
});

// Map and marker refs
const map = ref(null);
const marker = ref(null);
const maptilerKey = process.env.VUE_APP_MAPTILER_API_KEY;

onMounted(() => {
  map.value = L.map("map", {
    zoomControl: true,
    attributionControl: true,
  }).setView(props.coordinates, 6);

  L.tileLayer(
    `https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=${maptilerKey}`,
    {
      attribution:
        '&copy; <a href="https://www.maptiler.com/copyright/">MapTiler</a>',
      tileSize: 512,
      zoomOffset: -1,
    },
  ).addTo(map.value);
});

// Reactively update marker when coordinates change
watch(
  () => props.coordinates,
  (newCoords) => {
    if (map.value) {
      map.value.setView(newCoords, 15);

      if (marker.value) {
        marker.value.setLatLng(newCoords);
      } else {
        marker.value = L.marker(newCoords).addTo(map.value);
      }

      if (props.popupText) {
        marker.value.bindPopup(props.popupText).openPopup();
      }
    }
  },
  { immediate: true },
);
</script>

<style scoped></style>
